import {EmojiesList} from 'Event/Dashboard/components/EmojiList/emoji/EmojiesList'
import {useEvent} from 'Event/EventProvider'
import {api, isObvioApp, storage} from 'lib/url'
import {useOrganization} from 'organization/OrganizationProvider'
import {useState} from 'react'

export type Emoji = {
  name: string
  image?: string
  icon?: string
}

export const DEFAULT_EMOJIS = Object.values(EmojiesList)

export const emojiWithName = (name: string) => {
  const defaultEmoji = DEFAULT_EMOJIS.find((e) => e.name === name)
  if (defaultEmoji) {
    return defaultEmoji
  }

  return createCustomEmoji(name)
}

export const createCustomEmoji = (name: string): Emoji => ({
  name,
  image: storage(`/event/emojis/${name}`),
})

export function useSendEmoji() {
  const [sending, setSending] = useState(false)
  const {event, client} = useEvent()

  const send = (name: string) => () => {
    if (sending) {
      return
    }

    // Do not send emoji in admin/config because an error would cause the
    // user to logout.
    const isAdmin = isObvioApp()
    if (isAdmin) {
      return
    }

    setSending(true)
    setTimeout(() => setSending(false), 1000)
    const url = api(`/events/${event.id}/emoji_page`)

    client.post(url, {name}).catch((error) => {
      // ignore errors, prevent failing to send emoji from crashing app
      console.error(error)
    })
  }

  return {send, sending}
}

export function useDeleteEmojiFile() {
  const {event} = useEvent()
  const {client} = useOrganization()

  return (emoji: string) => {
    const url = api(`/events/${event.id}/emojis/${emoji}`)
    return client.delete(url)
  }
}
